import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Clock } from "lucide-react";
import { SITE } from "@/lib/site";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#070707]" data-testid="site-footer">
    <div className="mx-auto max-w-[1600px] px-6 md:px-10 py-16 md:py-24">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <span className="font-display text-4xl font-black tracking-tight text-white">TRX</span>
            <span className="text-[10px] font-semibold uppercase tracking-[0.3em] text-zinc-500 leading-tight">
              Auto Sales &<br />Service Inc
            </span>
          </div>
          <p className="mt-6 text-sm leading-relaxed text-zinc-500">
            Luxury dealership quality combined with expert performance shop capability. Premium vehicle sales, repairs,
            diagnostics, and performance upgrades.
          </p>
          <a
            href={SITE.facebook}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-facebook"
            className="mt-6 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-zinc-400 transition-colors hover:text-trx-blue"
          >
            <Facebook className="h-4 w-4" /> Follow on Facebook
          </a>
        </div>

        <div>
          <h4 className="eyebrow mb-6">Contact</h4>
          <ul className="space-y-4 text-sm text-zinc-400">
            <li>
              <a href={SITE.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 hover:text-white transition-colors">
                <Phone className="h-4 w-4 text-trx-blue" /> {SITE.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-white transition-colors">
                <Mail className="h-4 w-4 text-trx-blue" /> {SITE.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-0.5 text-trx-blue shrink-0" />
              <span>{SITE.address}</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="eyebrow mb-6">Hours</h4>
          <ul className="space-y-4 text-sm text-zinc-400">
            {SITE.hours.map((h) => (
              <li key={h.day} className="flex items-start gap-3">
                <Clock className="h-4 w-4 mt-0.5 text-trx-blue shrink-0" />
                <span>
                  {h.day}
                  <br />
                  <span className="text-zinc-500">{h.time}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="eyebrow mb-6">Explore</h4>
          <ul className="space-y-3 text-sm">
            {[
              ["Inventory", "/inventory"],
              ["Performance", "/performance"],
              ["Financing", "/financing"],
              ["Gallery", "/gallery"],
              ["Schedule Service", "/service"],
              ["Contact", "/contact"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`} className="text-zinc-400 transition-colors hover:text-white">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
        <p className="text-xs text-zinc-600">
          © {new Date().getFullYear()} TRX Auto Sales & Service Inc. All rights reserved.
        </p>
        <p className="text-xs text-zinc-600">
          Auto Repair · Used Cars · BMW Repair · Performance Shop · European Car Service — Statesville & Charlotte NC
        </p>
      </div>
    </div>
  </footer>
);
